import { useCouponRedemptionsByUserIdAndCouponCodeId } from '@raysee/hooks';
import { PresentIcon } from '@raysee/icon';
import { CouponCode, Message } from '@raysee/schema';
import { extractUrl } from '@raysee/utility';

interface Props {
  couponMessage: Message;
  couponCode?: CouponCode;
  userId: string;
  onClick: (text: string, message: Message) => void;
}

export const SuggestCouponBubble = (props: Props) => {
  const url = extractUrl(props.couponMessage.text);
  const [couponRedemptions] = useCouponRedemptionsByUserIdAndCouponCodeId(
    props.userId,
    props.couponCode?.id,
  );

  return (
    <>
      <div className="h-20" />
      <div className={'fixed bottom-0 flex w-full max-w-[480px] justify-center bg-white'}>
        <button
          onClick={() => props.onClick(url, props.couponMessage)}
          className={'bg-brand mx-3  my-4 flex-grow rounded-md border border-[#ff66c4] px-16 py-4'}
        >
          {couponRedemptions?.length ? (
            <div className={'flex items-center justify-center text-base font-bold text-white'}>
              クーポン使ってお得に占う！
            </div>
          ) : (
            <div className={'flex items-center justify-center'}>
              <PresentIcon />
              <div className="ml-3 text-base font-bold text-white">クーポンを受け取る</div>
            </div>
          )}
        </button>
      </div>
    </>
  );
};
